// import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import ReCAPTCHA from "react-google-recaptcha";
import config from "@/lib/config";
import { useRef, useEffect } from "react";
import styles from "@/styles/PaymentSelect.module.scss";

export default function RecaptchaV2({
  visible,
  setValue,
  setRecaptchaTokenV2,
  recaptchaCounterV2,
}) {
  if (!visible) return null;

  const recaptchaV2Ref = useRef(ReCAPTCHA);

  // recaptchaV2トークン生成
  const recaptchaChangeHandlerV2 = (value) => {
    setValue("recaptchaToken", value);
    setRecaptchaTokenV2(value);
  };

  // 決済登録失敗後チェックボックスのチェックを外すためにrecaptchaV2リセット
  useEffect(() => {
    recaptchaV2Ref.current.reset();
    setRecaptchaTokenV2(null);
  }, [recaptchaCounterV2]);

  return (
    <div className={styles.recaptchaV2}>
      <ReCAPTCHA
        ref={recaptchaV2Ref}
        name="recaptchaTokenV2"
        sitekey={config.reCAPTCHASiteKey.v2}
        theme="light"
        onChange={recaptchaChangeHandlerV2}
      ></ReCAPTCHA>
    </div>
  );
}
